document.addEventListener("DOMContentLoaded", function () {
    const accordions = document.querySelectorAll(".product__accordion details");

    // Open the first details by default and show its content
    if (accordions.length > 0) {
        accordions[0].setAttribute("open", "true");
        const firstContent = accordions[0].querySelector(".accordion__content");
        if (firstContent) firstContent.style.display = "block";
    }

    accordions.forEach((details) => {
        const summary = details.querySelector("summary");
        const content = details.querySelector(".accordion__content");

        summary.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default <details> toggle

            // If already open, slide up and close
            if (details.hasAttribute("open")) {
                slideUp(content, () => {
                    details.removeAttribute("open");
                });
            } else {
                // Close other open accordions smoothly
                accordions.forEach((otherDetails) => {
                    if (otherDetails !== details && otherDetails.hasAttribute("open")) {
                        slideUp(otherDetails.querySelector(".accordion__content"), () => {
                            otherDetails.removeAttribute("open");
                        });
                    }
                });

                // Open the clicked accordion
                details.setAttribute("open", "true");
                slideDown(content);
            }
        });
    });

    function slideUp(element, callback) {
        element.style.transition = "height 0.3s ease-out, opacity 0.3s ease-out";
        element.style.height = element.scrollHeight + "px";
        element.style.opacity = "1";
        requestAnimationFrame(() => {
            element.style.height = "0px";
            element.style.opacity = "0";
        });

        setTimeout(() => {
            element.style.display = "none";
            element.style.removeProperty("height");
            element.style.removeProperty("opacity");
            element.style.removeProperty("transition");
            if (callback) callback();
        }, 300);
    }

    function slideDown(element) {
        element.style.display = "block";
        let height = element.scrollHeight + "px";
        element.style.height = "0px";
        element.style.opacity = "0";
        element.style.transition = "height 0.3s ease-out, opacity 0.3s ease-out";
        requestAnimationFrame(() => {
            element.style.height = height;
            element.style.opacity = "1";
        });

        setTimeout(() => {
            element.style.removeProperty("height");
            element.style.removeProperty("opacity");
            element.style.removeProperty("transition");
        }, 300);
    }
});
